import React from "react";

import { css, cx } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseCloseCardButtonProps = {
  onClick: () => void;
};

export type CloseCardButtonProps = AtomProps<BaseCloseCardButtonProps, StyleClasses<"root" | "icon">>;

export const CloseCardButton: React.FC<CloseCardButtonProps> = ({ id, onClick, className, classes, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <Button
      data-action="common.card.close"
      variant="text"
      onClick={onClick}
      className={cx(styles.root, className, classes?.root)}
      {...props}
    >
      <Icons.doubleArrowRight className={cx(styles.icon, classes?.icon)} />
    </Button>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    top: 0,
    left: 0,
    position: "absolute",
    width: "fit-content",
    padding: theme.spacing(4),
    minWidth: 0,
  }),
  icon: css({
    width: FontSizes.caption,
    height: FontSizes.caption,
    color: theme.palette.grey[400],
  }),
});
